module.exports = __webpack_public_path__ + "img/silo_img4.8f843d88.jpeg";